import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import {SystemStatusAPI} from '../../services/admin/systemStatusAPI';

@inject(Router, AuthService, UserMessageService, SystemStatusAPI)
export class SystemStatus {
    constructor(router, authService, userMessageService, api) {

        this.router = router;
        this.authService = authService;
        this.userMessageService = userMessageService;
        this.api = api;
        this.date=new Date().getFullYear()+"-"+((new Date().getMonth()+1)>9?(new Date().getMonth()+1):"0"+(new Date().getMonth()+1));


    }

    activate() {
        this.load();
    }

    load() {
        this.api.getStatus(this.authService.getUser().token, this.date, this.getStatusSuccess.bind(this), this.apiError.bind(this));
    }

    getStatusSuccess(data) {
        this.setData(data);
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.refreshTimeout = setTimeout(this.load.bind(this), 50000);
    }

    apiError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData(status) {

      this.status = status;
      let incomeFromUsers=0;
      this.status.income.payingUser = status.income.payingUser.map(data=>{
          incomeFromUsers+=data.count * data.payment_total
          return {
            ...data,
            sub_total:data.count * data.payment_total
          }
        })

        if(isNaN(parseFloat(this.status.income.whiteLabelIncome)))
        this.status.income.whiteLabelIncome=0;
        this.status.income.incomeFromUsers=incomeFromUsers;
        this.status.income.incomeFromUsers=incomeFromUsers
        this.status.income.whiltelabelIncomeDiffrence=this.status.income.whiteLabelInvoice - this.status.income.whiteLabelIncome;


    }
    changeDate(){
      this.load()
    }

}
